module.exports = __webpack_public_path__ + "static/media/gioco.b3d7af16.jpeg";